/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarSpec } from './CarSpec';
import type { Specification } from './Specification';
import type { SupportedFeature } from './SupportedFeature';
import type { User } from './User';
export type Vehicle = {
  id?: number;
  carId?: string;
  diCarId?: string;
  vin?: string;
  ccsFullEnrollYn?: boolean;
  mainSupportYn?: boolean;
  primaryUserYn?: boolean;
  updatedBy?: string;
  updatedAt?: string;
  createdBy?: string;
  createdAt?: string;
  ccsAgreedNewTerms?: boolean;
  specificationId?: string;
  user?: User;
  specification?: Specification;
  role?: Vehicle.role;
  supportedFeatures?: Array<SupportedFeature>;
  carSpec?: CarSpec;
};
export namespace Vehicle {
  export enum role {
    NON_CCS = 'NON_CCS',
    MINOR_SPEC = 'MINOR_SPEC',
    PRIMARY_USER = 'PRIMARY_USER',
    SECONDARY_USER = 'SECONDARY_USER',
    INVALID = 'INVALID',
  }
}

